"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _fetchHelper = _interopRequireDefault(require("../../util/fetchHelper"));
var _environmentHelper = _interopRequireDefault(require("../../util/environmentHelper"));
var _appConfigHelper = require("../../util/appConfigHelper");
const updatePayPalPaymentDetails = async paymentMethodId => {
  const API_URL = (0, _environmentHelper.default)();
  const url = "".concat(API_URL, "/connectors/paypal/v1/payment_details/tokens");
  const redirectUrls = {
    successUrl: (0, _appConfigHelper.getData)('CLEENG_MYACCOUNT_PP_SUCCESS') ? "".concat((0, _appConfigHelper.getData)('CLEENG_MYACCOUNT_PP_SUCCESS')) : "".concat(window.location.origin, "/my-account/payment-info"),
    cancelUrl: (0, _appConfigHelper.getData)('CLEENG_MYACCOUNT_PP_CANCEL') || "".concat(window.location.origin, "/my-account/payment-info"),
    errorUrl: (0, _appConfigHelper.getData)('CLEENG_MYACCOUNT_PP_ERROR') || "".concat(window.location.origin, "/my-account/payment-info")
  };
  try {
    const res = await (0, _fetchHelper.default)(url, {
      method: 'POST',
      body: JSON.stringify({
        ...redirectUrls,
        paymentMethodId
      })
    });
    return res.json();
  } catch (e) {
    return e;
  }
};
var _default = exports.default = updatePayPalPaymentDetails;